import { RESET_FORM, UPDATE_FORM } from "../actions/DietitianForm.action";

const today = new Date();
today.setHours(12, 0, 0, 0);

const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
firstDayOfMonth.setHours(12, 0, 0, 0);

const initialState = {
    start_date: firstDayOfMonth,
    end_date: today,
    client_id: "",
    program_id: "",
    program_ids: [],
    zone_ids: [],
    region_ids: [],
    area_ids: [],
    city_ids: [],
    dietitian_ids: [],
};

const DietitianformReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_FORM:
            return { ...state, ...action.payload };

        case RESET_FORM:
            return { ...initialState };

        default:
            return state;
    }
};

export default DietitianformReducer;
